import React from 'react';
import { RemoveCircle } from '@mui/icons-material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { Charge } from '../../../types';

interface Props {
  rowIndex: number;
  onRemoveRow: VoidFunction;
}

export const ChargeTypeCell = ({ onRemoveRow, rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<Charge>>();
  const label = useWatch({ control, name: `bodyFields.${rowIndex}.label` });

  return (
    <Stack direction="row" alignItems="flex-start" gap="0.5rem">
      <Tooltip title="Remove charge">
        <IconButton className="icon-btn-bordered" size="small" color="error" onClick={onRemoveRow}>
          <RemoveCircle fontSize="small" />
        </IconButton>
      </Tooltip>

      <Typography>{label}</Typography>
    </Stack>
  );
};
